import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { PlayerSizesTypes } from '../../../../common/store/store.types';
import { flexColumn, flexColumnCenterCenter, flexColumnEndCenter } from '../../../../common/styles/flex';

interface StylesObject {
  volumeContainerStyle: { [key: string]: any };
  volumeBarContainerStyle: { [key: string]: any };
  volumeBarContainerWrapperStyle: { [key: string]: any };
  volumeBarStyle: { [key: string]: any };
  volumeBarBackgroundStyle: { [key: string]: any };
  volumeProgressBarStyle: { [key: string]: any };
}

const volumeContainer = {
  ...flexColumnEndCenter,
  alignSelf: 'flex-end',
  pointerEvents: 'auto',
  marginRight: '8px',
  mobile: {
    marginRight: '0px',
  },
  largeAndExtraLarge: {
    marginRight: '4px',
  },
  outsideControlsBar: {
    marginLeft: '12px',
  },
  remove: {
    display: 'none',
  },
  hide: {
    pointerEvents: 'none',
  },
};

const volumeBarContainerWrapper = {
  position: 'relative',
  overflow: 'hidden',
  pointerEvents: 'auto',
  small: {
    display: 'none',
  },
  medium: {
    width: '24px',
    height: '100px',
    marginBottom: '11px',
    mobile: {
      display: 'none',
    },
  },
  largeAndExtraLarge: {
    marginBottom: '12px',
    width: '32px',
    height: '134px',
  },
  hide: {
    visibility: 'hidden',
    pointerEvents: 'none',
  },
  remove: {
    display: 'none',
  },
};

const volumeBarContainer = {
  ...flexColumnCenterCenter,
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.TINY,
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  backgroundColor: SITE_VARIABLES.COLORS.BLACK_TRANSPARENT,
  position: 'absolute',
  transition: '0.4s',
  medium: {
    width: '24px',
    height: '100px',
    bottom: '-100px',
  },
  largeAndExtraLarge: {
    width: '32px',
    height: '134px',
    bottom: '-134px',
  },
  hover: {
    bottom: '0',
  },
};

const volumeBar = {
  ...flexColumn,
  alignItems: 'center',
  position: 'absolute',
  cursor: 'pointer',
  width: '8px',
  medium: {
    height: '80px',
  },
  largeAndExtraLarge: {
    height: '110px',
  },
};

const volumeBarBackground = {
  position: 'absolute',
  width: '4px',
  height: '100%',
  overflow: 'hidden',
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.SMALL,
  backgroundColor: SITE_VARIABLES.COLORS.GRAY_TRANSPARENT,
};

const getVolumeProgressBarStyle = (backgroundColor: string): any => ({
  position: 'absolute',
  width: '4px',
  bottom: '0',
  borderRadius: SITE_VARIABLES.BORDER_RADIUS.SMALL,
  transition: '0.4s',
  backgroundColor,
  hide: {
    display: 'none',
  },
});

export const getVolumeStyleObject = (playerSize: PlayerSizesTypes, showVolumeBar: boolean, muted: boolean, desktopMode: boolean, splitView: boolean, brandColor: string | null, showControls: boolean, showAdControls: boolean, outsideControlsBar?: boolean): StylesObject => {
  const color = brandColor || SITE_VARIABLES.COLORS.WHITE;
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  const largeOrExtraLargeSize = largeSize || extraLargeSize;
  const volumeProgressBar = getVolumeProgressBarStyle(color);

  return ({
    volumeContainerStyle: [
      volumeContainer,
      largeOrExtraLargeSize && volumeContainer.largeAndExtraLarge,
      outsideControlsBar && desktopMode && volumeContainer.outsideControlsBar,
      !desktopMode && volumeContainer.mobile,
      outsideControlsBar && !showControls && (!showAdControls || desktopMode) && volumeContainer.remove,
      !showVolumeBar && volumeContainer.hide,
    ],
    volumeBarContainerWrapperStyle: [
      volumeBarContainerWrapper,
      smallSize && volumeBarContainerWrapper.small,
      mediumSize && volumeBarContainerWrapper.medium,
      mediumSize && !desktopMode && volumeBarContainerWrapper.medium.mobile,
      largeOrExtraLargeSize && volumeBarContainerWrapper.largeAndExtraLarge,
      !showVolumeBar && volumeBarContainerWrapper.hide,
      outsideControlsBar && volumeBarContainerWrapper.remove,
    ],
    volumeBarContainerStyle: [
      volumeBarContainer,
      mediumSize && volumeBarContainer.medium,
      mediumSize && showVolumeBar && volumeBarContainer.hover,
      largeOrExtraLargeSize && volumeBarContainer.largeAndExtraLarge,
      largeOrExtraLargeSize && showVolumeBar && volumeBarContainer.hover,
    ],
    volumeBarStyle: [
      volumeBar,
      mediumSize && volumeBar.medium,
      largeOrExtraLargeSize && volumeBar.largeAndExtraLarge,
    ],
    volumeBarBackgroundStyle: {
      ...volumeBarBackground,
    },
    volumeProgressBarStyle: [
      volumeProgressBar,
      muted && volumeProgressBar.hide,
    ],
  });
};
